









import { Tag } from '@/models/opportunities';
import Vue from 'vue';

export default Vue.extend({
  name: 'OpportunityTags',
  props: {
    tags: Array as () => Tag[],
  },
});
